<template>
  <v-layout>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-flex xs8>
            <h2>التعليقات</h2>
          </v-flex>
          <v-flex xs4 text-sm-left>
            <add-comment @updateComment="updateComment" :missing-id="missingId"></add-comment>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-layout column v-for="comment in comments" :key="comment.id">
            <v-flex xs10>
              <p>{{comment.body}}</p>
              <h6 class="text-muted time">{{comment.created_at}}</h6>
            </v-flex>
            <v-flex xs2 text-sm-left>
              بواسطة
              <a href="#">
                <b>{{comment.user.fullName}}</b>
              </a>
            </v-flex>
            <hr />
          </v-layout>
          <hr />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import AddComment from "./AddComment";
import { Endpoint } from "../../config.js";
export default {
  props: {
    missingId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      comments: []
    };
  },
  components: {
    AddComment
  },
  methods: {
    updateComment() {
      var _this = this;
      axios
        .get(`${Endpoint}/api/missing/${this.$route.params.id}/comments`)
        .then(response => {
          _this.comments = response.data.comments;
        });
    }
  },
  mounted() {
    this.comments = [];
    this.updateComment();
    this.$forceUpdate();
  },
  created() {}
};
</script>

<style  scoped>
</style>
